import { post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import UpdatePriorityTargetRequest from "../form/request/UpdatePriorityTargetRequest";

const API_PREFIX = "/selfEvaluation";

export const save = request => {
  console.log("request", request);
  return post(
    `${API_PREFIX}/selfPriorityTarget`,
    new UpdatePriorityTargetRequest(request),
    authHeader()
  ).then(response => {
    console.log("response", response);
    return response.data;
  });
};
